import { Injectable } from '@angular/core';
import {
  ConfigFileUploading,
  ConfigurationFileFilterModel,
  InitialConfigFileFilterModel,
} from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private readonly apiService: ApiService) {}

  uploadShipments(file: File): Observable<any> {
    const formData = new FormData();

    formData.append('file', file, file.name);
    return this.apiService.post('/devices/uploadShipments', formData);
  }

  getShipments(limit: number = 10, offset: number = 0): Observable<any> {
    const filter = { limit, offset };
    return this.apiService.get(`/devices/shipments`, filter as any);
  }

  getShipmentDetails(shipmentId: string): Observable<any> {
    return this.apiService.get(`/devices/shipments/${shipmentId}`);
  }

  uploadDCF(payload: ConfigFileUploading): Observable<any> {
    const formData = new FormData();

    formData.append('file', payload.file, payload.file.name);
    formData.append('device_type', payload.deviceType);
    const partnerOids = payload.partnerOids.filter(id => id.length > 0);
    for (const partnerOid of partnerOids) {
      formData.append('partner_oids', partnerOid);
    }
    if (payload.firmwareVersions.length > 0) {
      formData.append('firmware_versions', payload.firmwareVersions.toString());
    }
    return this.apiService.post('/devices/device-configuration', formData);
  }

  getDeviceConfigFileDetails(fileId: number): Observable<any> {
    return this.apiService.get(`/devices/device-configuration/${fileId}`);
  }

  getDeviceConfigFileContentByVersionId(fileId: number, versionId: number): Observable<any> {
    return this.apiService.getText(
      `/devices/device-configuration/${fileId}/content?versionId=${versionId}`,
    );
  }

  deleteDeviceConfigFile(fileId: number): Observable<any> {
    return this.apiService.delete(`/devices/device-configuration/${fileId}`);
  }

  getDeviceConfigFiles(filter: ConfigurationFileFilterModel): Observable<any> {
    const params = Object.fromEntries(Object.entries(filter).filter(([, v]) => v !== undefined));
    return this.apiService.get(`/devices/device-configuration`, params as any);
  }

  getShipmentContent(shipmentId: string): Observable<any> {
    return this.apiService.getText(`/devices/shipments/${shipmentId}/content`);
  }

  getInitialConfigFiles(filter: InitialConfigFileFilterModel): Observable<any> {
    const params = Object.fromEntries(Object.entries(filter).filter(([, v]) => v !== undefined));
    return this.apiService.get('/devices/initial-configuration', params as any);
  }

  getInitialConfigFileDetails(fileId: number): Observable<any> {
    return this.apiService.get(`/devices/initial-configuration/${fileId}`);
  }

  getInitialConfigFileContentByVersionId(fileId: number, versionId: number): Observable<any> {
    return this.apiService.getText(
      `/devices/initial-configuration/${fileId}/content?versionId=${versionId}`,
    );
  }

  deleteInitialConfigFile(fileId: number): Observable<any> {
    return this.apiService.delete(`/devices/initial-configuration/${fileId}`);
  }

  uploadICF(payload: ConfigFileUploading): Observable<any> {
    const formData = new FormData();
    formData.append('file', payload.file, payload.file.name);
    formData.append('deviceType', payload.deviceType);
    const partnerOids = payload.partnerOids.filter(id => id.length > 0);
    for (const partnerOid of partnerOids) {
      formData.append('partnerOids', partnerOid);
    }
    if (payload.firmwareVersions.length > 0) {
      formData.append('firmwareVersions', payload.firmwareVersions.toString());
    }
    return this.apiService.post('/devices/initial-configuration', formData);
  }
}
